import { Field } from '@ui/lib/park/ui/field';
import { ReactNode } from 'react';

export const Error = ({ msg }: { msg: ReactNode }) => {
  return (
    <Field.ErrorText
      textStyle="text.small"
      mt={2}
      display="block"
      w="full"
      maxW="full"
      whiteSpace="pre-line"
      overflowWrap="anywhere"
      wordBreak="break-word"
    >
      {msg}
    </Field.ErrorText>
  );
};
